var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttempted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EFF2FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C18.3175 2 21.5094 3.26828 23.9222 5.54511C26.3349 7.82195 27.786 10.9351 27.9782 14.2469C28.1703 17.5588 27.0891 20.8189 24.9558 23.3595C22.8226 25.9001 19.7988 27.5291 16.5036 27.9128C13.2084 28.2965 9.89119 27.4059 7.23126 25.4234C4.57134 23.4409 2.76996 20.5165 2.19603 17.2491C1.62209 13.9816 2.31903 10.6184 4.14411 7.84811C5.96919 5.07781 8.78432 3.11005 12.013 2.34781L15 15V2Z",
    fill: "#27387D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempted);
export default __webpack_public_path__ + "static/media/attempted.dfc6a650fb3792834a330f584d3ea487.svg";
export { ForwardRef as ReactComponent };